import { PersonalInformationPage } from "client/Features/PersonalInformationPage/PersonalInformationPage";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./Section.module.less";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";

export type SectionEmptyBehavior = "placeholder" | "not-render";

export type SectionProps = {
	title: string;
	trackingId: string;
	isEmpty?: boolean;
	emptyBehavior: SectionEmptyBehavior;
};

export const Section = (props: PropsWithChildren<SectionProps>): ReactElement | null => {
	const {
		title,
		trackingId,
		isEmpty = false,
		emptyBehavior,
		children
	} = props;

	if (isEmpty && emptyBehavior === "not-render") {
		return null;
	}

	const renderContent = (): ReactElement | null => {
		if (isEmpty) {
			switch (emptyBehavior) {
				case "placeholder":
					return (
						<div className={styles.emptyPlaceholder}>
							{localize("_NotFilledInYet")}
						</div>
					);
				case "not-render":
					throw new Error("In case of not-render entire component must return null.");
				default:
					never(emptyBehavior);
			}
		}

		return <>{children}</>;
	};

	return (
		<PersonalInformationPage.Section
			title={title}
			trackingId={trackingId}
		>
			{renderContent()}
		</PersonalInformationPage.Section>
	);
};
Section.displayName = "Section";